import { render, staticRenderFns } from "./MkObjPopup.vue?vue&type=template&id=e6801a58&"
import script from "./MkObjPopup.vue?vue&type=script&lang=js&"
export * from "./MkObjPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports